module.exports = __webpack_public_path__ + "static/media/Google Logo.c8bf7c08.png";